<template>
  <div class="footerbox">
    <div class="box" v-if="isKuaishou==1&&showTech==1&&siteInfo!=null">
      {{siteInfo.certCn}}
    </div>
    <div class="box" v-if="isKuaishou!=1&&siteInfo!=null">
      <div class="kfsinfo" v-if="kfsData">
        <span v-if="kfsData.developerName">开发商：{{kfsData.developerName}}</span>
        <span v-if="kfsData.permit">预售证：{{kfsData.permit}}</span>
      </div>
      <p @click="aboutUsClick()" style="cursor:pointer;">关于我们</p>
      <p>{{siteInfo.certEn}}</p>
      <p>公司:{{siteInfo.companyName}} {{siteInfo.frontName}}</p>
      <p>地址:{{siteInfo.addr}}</p>
      <p>{{businessRang}}</p>
      <p><a target="_blank" href="javascript:void(0);"  onclick="javascript:window.open('https://beian.miit.gov.cn/');">{{siteInfo.certCn}}</a></p>
      <p>服务热线:{{siteInfo.serviceTel}}</p>
      <p v-if="siteInfo.tsTell">投诉电话:{{siteInfo.tsTell}}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Footer',
  props:{
    kfsData:Object,
    isKuaishou:String|Number,
    showTech:String|Number
  },
  mounted(){
    var _this = this;
    _this.getInfo();
    _this.getSitePlatFormValidCode();
  },
  data () {
    return {
      siteInfo:{},
      icp:'11081961',
      businessRang:''
    }
  },
  methods:{
    getInfo:function(){
      var url = window.location.href;
      this.$http.get('/api/custome/getSiteInfo').then((response)=>{

        this.siteInfo=response.data.result;

        if(url.indexOf('qqbdc')!=-1 || url.indexOf('mtianxia')!=-1 || url.indexOf('salehg')!=-1){

          if(url.indexOf('recommend')!=-1){

              this.businessRang ="经营范围：一般经营项目是：公司的经营范围为： 网络技术开发；计算机软硬件技术开发、销售；经济信息咨询；房地产信息咨询；房地产销售；房地产代理；房地产经纪；房地产中介；从事广告业务；网页设计。（法律、行政法规、国务院决定禁止的项目除外，限制的项目须取得许可后方可经营）。";
          }
        }

        if(url.indexOf('mtxfang')!=-1 || url.indexOf('metianxia')!=-1 || url.indexOf('hbaichi')!=-1){

           if(url.indexOf('recommend')!=-1){
              this.businessRang ="经营范围：一般经营项目是：经营电子商务；文化活动策划；企业形象策划；企业管理咨询；展览展示策划；商务信息咨询；品牌策划；公关策划；计算机软硬件技术开发与销售；国内贸易；会议服务；从事广告业务；市场营销策划；网站设计；经济信息咨询；计算机系统集成服务；网络技术、电子技术、互联网技术领域内的技术开发、技术服务、技术转让；房地产信息咨询；房地产经纪。（法律、行政法规、国务院决定禁止的项目除外，限制的项目须取得许可后方可经营），许可经营项目是：媒体运营；互联网信息服务。";
          }

         }

      }).catch((response)=>{
        console.log(response)
      })
    },
    getSitePlatFormValidCode:function(){
        //查询code码和value
        this.$http.get('/api/index/getSitePlatFormValidCode').then((response)=>{
        let bean =response.data.result;
        if(bean!=null){
          //设置meta
          document.getElementsByTagName('meta')[1].content = bean.code;
          // 创建script标签，执行script内容
          let script = document.createElement('script')
          script.type = 'text/javascript'
          script.src = "https://hm.baidu.com/hm.js?"+ bean.value;
          script.async = "async";
          document.getElementsByTagName('head')[0].appendChild(script);
        }
      }).catch((response)=>{
        console.log(response)
      })

    },
    aboutUsClick:function(){
      this.$router.push({path:'/aboutUs'});
    }
  }
}
</script>

<style scoped>
.footerbox{margin-top:50px;border-top:1px solid #EBEBEB;background:#f5f5fa;padding:30px 0 40px;font-size:14px;color:#999;line-height:20px;text-align:center;}
.footerbox p{padding:3px 0;}
.kfsinfo{font-size:10px;color:#333;margin-bottom:15px;}
.kfsinfo span{display:block;}

@media (max-width:768px){
  .footerbox{margin-top:0;padding:0;background:#fff;font-size:9px;line-height:14px;}
  .footerbox .box{padding:15px;margin-top:10px;box-sizing:border-box;}
}
</style>



// WEBPACK FOOTER //
// src/components/public/Footer.vue